export class TypePredicateManager {
  // Html elements check
  static isHTMLElementByTagName<T extends keyof HTMLElementTagNameMap>(element: Element, tagName: T): element is HTMLElementTagNameMap[T] {
    return element.tagName.toLowerCase() === tagName.toLowerCase();
  }

  // Functions Check
  static hasFocusFunction(element: Element): element is Element & { focus: () => void } {
    return typeof (element as Element & { focus?: () => void }).focus === "function";
  }
}
